import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { apiEndpoints, serverUrl } from "../../config";

import { Container, Col, Row } from "react-bootstrap";
import {
  Dialog,
  Box,
  DialogContent,
  Button,
  Typography,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";

import CompanyappLoader from "../companyappLoader";
import ClearIcon from "@mui/icons-material/Clear";

import DialogPaper from "../dialogPaper";
import { getOnlineNode } from "../../core/getNode";

export default function WebformSelector(props) {
  const [showSelector, setShowSelector] = useState(false);
  const [selection, setSelection] = useState(props.selectedWebform || null);
  const [searchTitle, setSearchTitle] = useState("");
  const [searchId, setSearchId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);


  const user = useSelector((state) => state).authReducer.user;

  useEffect(() => {
    getContent();
    // eslint-disable-next-line
  }, []);

  const insertSelections = () => {
    if (props.insertSelections) {
      props.insertSelections(selection);
    }
  };

  const renderSearchFilters = () => {
    return (
      <Row className="entity-search-filter">
        <Col xs={6}>
          <TextField
            className="w-100"
            label="Title"
            variant="outlined"
            size="small"
            value={searchTitle}
            onChange={(e) => setSearchTitle(e.target.value)}
            placeholder="Search title"
            InputProps={{
              endAdornment: searchTitle && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTitle("")}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Col>

        <Col xs={4}>
          <TextField
            className="w-100"
            label="ID"
            variant="outlined"
            size="small"
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
            placeholder="Search ID..."
            InputProps={{
              endAdornment: searchId && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchId("")}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Col>
        <Col xs={2} className="d-flex gap-2">
          <Row>
            <Col xs={6}>
              <Button
                className="w-100 h-100 entity-search-btn"
                owner="admin"
                variant="outlined"
                dialogbtn="true"
                dialogvariant="cancel"
                onClick={resetFilters}
              >
                <Typography owner="admin" variant="button">
                  Reset
                </Typography>
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                className="w-100 h-100 entity-search-btn"
                owner="admin"
                variant="contained"
                dialogbtn="true"
                dialogvariant="primary"
                onClick={() => {
                  setIsLoading(true);
                  getContent();
                }}
              >
                <Typography owner="admin" variant="button">
                  Search
                </Typography>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const resetFilters = () => {
    setSearchTitle("");
    setSearchId("");
    setResults([]);
  };

  const handleSelect = (item) => {
    setSelection(item?.webform?.id);
  };

  const webformItem = (item) => {
    const isSelected = item?.webform?.id === selection;
    return (
      <Col
        xs={2}
        key={`entity--${item.id}`}
        className={`entity-item${isSelected ? " selected" : ""}`}
        onClick={() =>  handleSelect(item)}
        style={{ cursor: "pointer" }}
      >
        <div className="entity-item-redactor d-flex flex-column w-100 h-100">
          <Row className="gx-0">
            <div className="entity-thumbnail-container ratio ratio-16x9">
              <img
                src={`${serverUrl}${item.field_featured_image}`}
                alt={`${item.title}-thumbnail`}
              />
            </div>
          </Row>
          <Row className="gx-0">
            <Typography
              className="entity-item-title"
              owner="admin"
              variant="h6"
            >
              {item.title}
            </Typography>
          </Row>
        </div>
      </Col>
    );
  };

  const renderItems = (items) => {
    return (
      <>
        {isLoading ? (
          <CompanyappLoader />
        ) : (
          <Row className="entity-items-container d-flex align-items-stretch">
            {items.map((item) => webformItem(item))}
          </Row>
        )}
      </>
    );
  };

  const getContent = () => {
    const params = new URLSearchParams();
    if (searchTitle) params.set("id_or_title", searchTitle);
    if (searchId) params.set("id", searchId);
    const queryString = params.toString();
    // The v3 webforms endpoint includes each host node's webform machine
    // name (`row.webform.id`), which the event save needs — the v2 forms
    // view doesn't expose it.
    const path = `${apiEndpoints.webforms || apiEndpoints.forms}?${queryString}`;

    getOnlineNode(path, user.access_token)
      .then((response) => {
        setResults(response.data.rows);
        setIsLoading(false);
      })
      .catch((_error) => {
        setIsLoading(false);
        console.error(_error);
      });
  };

  return (
    <>
      <Button
        variant="contained"
        owner="admin"
        onClick={() => setShowSelector(true)}
      >
        <Typography owner="admin" variant="button">
          Attach Webform
        </Typography>
      </Button>
      <Dialog
        className="ps-modal entity-selector-modal"
        open={showSelector}
        maxWidth={"lg"}
        fullWidth={true}
        onClose={(event, reason) => {
          if (reason && reason === "backdropClick") return;
          setShowSelector(false);
        }}
        PaperComponent={DialogPaper}
      >
        <Box className="ps-modal-title dialog-draggable-handle">
          <Container fluid>
            <Row className="align-items-center">
              <Col xs={12} sm={6}>
                <Typography variant="h3" owner="admin" color="adminText.dark">
                  Webform Selector
                </Typography>
              </Col>
              <Col xs={12} sm={6}>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                >
                  <Button
                    variant="outlined"
                    owner="admin"
                    dialogbtn="true"
                    dialogvariant="cancel"
                    onClick={() => setShowSelector(false)}
                  >
                    <Typography variant="button" owner="admin" className="lh">
                      Cancel
                    </Typography>
                  </Button>
                  <Button
                    variant="contained"
                    owner="admin"
                    dialogbtn="true"
                    dialogvariant="save"
                    className="lh"
                    onClick={() => {
                      insertSelections();
                      setShowSelector(false);
                    }}
                  >
                    <Typography variant="button" owner="admin" className="lh">
                      Select
                    </Typography>
                  </Button>
                </Stack>
              </Col>
            </Row>
          </Container>
        </Box>
        <DialogContent>
          <Box className="ps-modal-content">
            <Container>{renderSearchFilters()}</Container>
            <Container>{results && renderItems(results)}</Container>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
